import cevsen from 'data/cevsen'

export const getCevsenGroupedPageForBab = (bab: number): number | null => {
  if (!Number.isInteger(bab) || bab < 1 || bab > 101) return null
  if (bab === 101) return 10
  return Math.ceil(bab / 10)
}

export const getCevsenRouteForBab = (bab: number): string | null => {
  const groupedPage = getCevsenGroupedPageForBab(bab)
  if (!groupedPage) return null

  return `/cevsen/${groupedPage}#bolum-${bab}`
}

export const getCevsenPage = (page: string) => {
  const pageAsNumber = Number(page)
  if (pageAsNumber > 0 && pageAsNumber < 11) {
    const firstPartIndex = pageAsNumber * 10 - 9
    const lastPartIndex = firstPartIndex + 9
    const data = {}
    for (let i = firstPartIndex; i <= lastPartIndex; i++) {
      // @ts-ignore
      data[i] = cevsen[i]
    }
    if (pageAsNumber === 10) {
      // @ts-ignore
      data[101] = cevsen[101]
    }
    return data
  }
  return null
}
